import apiCompetitiveActivity from '@/api/competitive-activity'

const state = {
  data: [],
  isLoading: false,
  validationErrors: null,
}

export const mutationTypes = {
  getCompetitiveActivityStart:
    '[competitive activity item] getCompetitiveActivity item Start',
  getCompetitiveActivitySuccess:
    '[competitive activity item] getCompetitiveActivity item Success',
  getCompetitiveActivityFailure:
    '[competitive activity item] getCompetitiveActivity item Failure',
}

export const actionType = {
  getCompetitiveActivity:
    '[competitive activity item ] getCompetitive item Activity',
}

const mutations = {
  [mutationTypes.getCompetitiveActivityStart](state) {
    state.isLoading = true
    state.validationErrors = null
    state.data = []
  },

  [mutationTypes.getCompetitiveActivitySuccess](state, payload) {
    state.isLoading = false
    state.data = payload
  },

  [mutationTypes.getCompetitiveActivityFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.getCompetitiveActivity](context, type_id) {
    context.commit(mutationTypes.getCompetitiveActivityStart)
    return new Promise((resolve) => {
      apiCompetitiveActivity
        .getCompetitiveActivityList(type_id)
        .then((response) => {
          context.commit(
            mutationTypes.getCompetitiveActivitySuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getCompetitiveActivityFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
